import { numberToDelimited } from 'builder/utils/numberToDelimited'
import { SkeletonValue } from '../Skeletons'
import * as CommonStyles from '../../styles'
import * as Styles from './styles'

type Props = {
  salary?: number | null
  isSkeleton: boolean
}

export const SalaryInfo = ({ salary, isSkeleton = false }: Props) => {
  if (!salary && !isSkeleton) return null

  return (
    <Styles.Container>
      <CommonStyles.Title>Avg. salary:</CommonStyles.Title>
      {isSkeleton ? (
        <SkeletonValue />
      ) : (
        typeof salary === 'number' && (
          <CommonStyles.Value>${numberToDelimited(salary)}</CommonStyles.Value>
        )
      )}
    </Styles.Container>
  )
}
